module.exports = __webpack_public_path__ + "static/img/track.293069c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/track.png
// module id = DWRS
// module chunks = 50